<template>
    <div class="pb-64">        
        <p class="my-4 text-lg">Enable automatic reminders to your customers when they don't respond to feedback invites. These settings will also be applied to Dev API email invites.</p>        
        <div class="p-4 my-3 text-lg font-medium rounded flex items-center lightbrandbg">
            <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
            <span>
                <p>To maintain high email deliverability (and reduce SPAM signals), please be respectful of your recipients' privacy. On the final email, be sure to specify that they will not be bothered again.</p>                
            </span>
        </div>       


        <div class="vx-card p-5 py-6">
            <p class="mb-6 flex max-w-lg font-semibold" >Send an initial followup email 
            <vs-switch class="ml-2" v-model="followupOnce">
              <span slot="on">On</span>
              <span slot="off">Off</span> 
            </vs-switch></p>   
            <vs-radio vs-name="onceperiod" :disabled="!followupOnce" v-model="followupPeriodOnce" vs-value="2d" class="mr-3 text-dark font-medium">                
                <p class="text-center">2 days after invite</p>
            </vs-radio>     
            <vs-radio vs-name="onceperiod"  :disabled="!followupOnce" v-model="followupPeriodOnce" vs-value="3d" class="mr-3  text-dark font-medium">                
                <p class="text-center">3 days after invite</p>
            </vs-radio>     
            <vs-radio vs-name="onceperiod"  :disabled="!followupOnce" v-model="followupPeriodOnce" vs-value="7d" class="mr-3 text-dark font-medium">                
                <p class="text-center">7 days after invite</p>
            </vs-radio>     
            <p class="mt-6 mb-4 max-w-lg" >How would you like to followup initially?</p>        
            <vs-textarea :disabled="!followupOnce" name="Followup text" v-validate="'max:300|required'" size="large" class="w-full" placeholder="We noticed we haven't received your feedback. Could you please take a moment to let us know how we did? Your input is valuable to us. Thank you!" v-model="followupTextOnce"/>
            <span class="text-danger block mt-2">{{ errors.first('Followup text') }}</span>
        </div>       
        <vs-collapse type="margin" class="small mb-10">
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-eye" class="text-left p-4">
              <div slot="header">
                Initial Followup Preview
              </div>
              <div>
                <StarPreview :changePrompt="followupTextOnce" v-if="entityRatingType === 'star'" />
                <CSATPreview :changePrompt="followupTextOnce" v-if="entityRatingType === 'csat'" />
                <NPSPreview :changePrompt="followupTextOnce" v-if="entityRatingType === 'nps'" />
            </div>
            </vs-collapse-item>
          </vs-collapse>



        <div class="vx-card mt-4 p-5 py-6" v-if="followupOnce">
            <p class="mb-4 flex max-w-lg font-semibold" >Send a final followup email 
            <vs-switch class="ml-2" v-model="followupTwice">
              <span slot="on">On</span>
              <span slot="off">Off</span> 
            </vs-switch></p>     
            <vs-radio vs-name="twiceperiod"   :disabled="!followupTwice" v-model="followupPeriodTwice" vs-value="2d" class="mr-3 text-dark font-medium">                
                <p class="text-center">2 days after initial followup</p>
            </vs-radio>     
            <vs-radio vs-name="twiceperiod"  :disabled="!followupTwice" v-model="followupPeriodTwice" vs-value="3d" class="mr-3 text-dark font-medium">                
                <p class="text-center">3 days after initial followup</p>
            </vs-radio>     
            <vs-radio vs-name="twiceperiod"  :disabled="!followupTwice"  v-model="followupPeriodTwice" vs-value="7d" class="mr-3 text-dark font-medium">                
                <p class="text-center">7 day after initial followup</p>
            </vs-radio>                    
            <p class="mt-6 mb-4 max-w-lg" >How would you like to followup on the final email?</p>        
            <vs-textarea :disabled="!followupTwice" name="Final followup text" v-validate="'max:300|required'" size="large" class="w-full" placeholder="We noticed we haven't received your feedback. Could you please take a moment to let us know how we did? Your input is valuable to us. Thank you!" v-model="followupTextTwice"/>
            <span class="text-danger block mt-2">{{ errors.first('Final followup text') }}</span>
        </div>
        <vs-collapse type="margin" class="small mb-10">
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-eye" class="text-left p-4">
              <div slot="header">
                Final Followup Preview
              </div>
              <div>
                <StarPreview :changePrompt="followupTextTwice" v-if="entityRatingType === 'star'" />
                <CSATPreview :changePrompt="followupTextTwice" v-if="entityRatingType === 'csat'" />
                <NPSPreview :changePrompt="followupTextTwice" v-if="entityRatingType === 'nps'" />
            </div>
            </vs-collapse-item>
          </vs-collapse>
        
        <savebutton submitText="Update" :accept="update" :goodToGo="formReady" />
    </div>
</template>

<script>

    import NPSPreview from '../emailpreviewcomponents/npspreview.vue'
    import CSATPreview from '../emailpreviewcomponents/csatpreview.vue'
    import StarPreview from '../emailpreviewcomponents/starpreview.vue'
    import Savebutton from '../components/ptcomponents/Savebutton.vue'

export default {
    data() {
        return {
            startingData: '',
            followupTextOnce: 'We noticed we haven\'t received your feedback. Could you please take a moment to let us know how we did? Your input is valuable to us. Thank you!',
            followupTextTwice: 'We don\'t want to miss your thoughts on our recent interaction. Could you please take a moment to tell us how we did? Your feedback is essential to us, and we appreciate your time. We will not trouble you again after this email.',
            followupPeriodOnce: '2d', 
            followupPeriodTwice: '2d', 
            followupOnce: false,
            followupTwice: false
        }
    },
    computed: {
        entityRatingType() {
            return this.$store.state.dash.viewData.business.surveySetup.ratingType
        },
        formReady() {
            if (this.startingData === this.getNowStateJSON()) {
                return false
            } else {
                if (this.errors.any()) return false
            }
            return true
        }
    },
    components: {
        Savebutton,
        StarPreview,
        NPSPreview,
        CSATPreview
    },
    methods: {
        getNowStateJSON() {
            return JSON.stringify({
                followupTextOnce: this.followupTextOnce,
                followupTextTwice: this.followupTextTwice,
                followupPeriodOnce: this.followupPeriodOnce, 
                followupPeriodTwice: this.followupPeriodTwice, 
                followupOnce: this.followupOnce,
                followupTwice: this.followupTwice
            })
        },
        update() {
            this.$store.dispatch('dash/UPDATE_EMAIL_SETTINGS', {
                followupTextOnce: this.followupTextOnce,
                followupTextTwice: this.followupTextTwice,
                followupPeriodOnce: this.followupPeriodOnce, 
                followupPeriodTwice: this.followupPeriodTwice, 
                followupOnce: this.followupOnce,
                followupTwice: this.followupTwice
            }).then(() => {
        this.$vs.notify({
          title: 'Update Email Follwup Settings',
          text: 'Followup settings updated successfully',
          color: 'success',
          time: 5000,
          iconPack: 'feather',
          icon:'icon-check'})
          this.startingData = this.getNowStateJSON()
      }).catch(() => {
        this.$vs.notify({
          title: 'Update Email Follwup Settings',
          text:'Oops! Something went wrong, and we couldn\'t update your email settings. Please try again, and reach out for support if it happens again.',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      })                        
        },
        init() {
            //does exist on entity
            const preState = this.$store.getters['dash/emailSettings']
            if (preState) {
                this.followupTextOnce = preState.followupTextOnce,
                this.followupTextTwice =  preState.followupTextTwice,
                this.followupPeriodOnce = preState.followupPeriodOnce, 
                this.followupPeriodTwice = preState.followupPeriodTwice, 
                this.followupOnce = preState.followupOnce,
                this.followupTwice = preState.followupTwice    
            }
        this.startingData = JSON.stringify({
                followupTextOnce: this.followupTextOnce,
                followupTextTwice: this.followupTextTwice,
                followupPeriodOnce: this.followupPeriodOnce, 
                followupPeriodTwice: this.followupPeriodTwice, 
                followupOnce: this.followupOnce,
                followupTwice: this.followupTwice
            })            
        }
    },
    created() {        

        this.init()
       
    }
}

</script>